import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

const PremioTotaleCard = ({ premioTotale, onBack, onContinua }) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        border: "2px solid",
        borderColor: (theme) =>
          theme.palette.mode === "dark" ? "#13b86d" : "#13b86d",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box>
            <Typography variant="h5" fontWeight={700}>
              Premio Totale
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Somma di tutte le garanzie selezionate
            </Typography>
          </Box>
          <Box textAlign="right">
            <Typography variant="h3" fontWeight={700} sx={{ color: "#13b86d" }}>
              {premioTotale}.00€
            </Typography>
            <Typography variant="caption" color="text.secondary">
              all'anno
            </Typography>
            <Typography
              variant="caption"
              display="block"
              color="text.secondary"
            >
              {(premioTotale / 12).toFixed(2)}€/mese
            </Typography>
          </Box>
        </Box>

        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            size="large"
            onClick={onBack}
            sx={{
              flex: 1,
              borderColor: "#13b86d",
              color: "#13b86d",
              "&:hover": {
                borderColor: "#10ac7d",
                bgcolor: "rgba(19, 184, 109, 0.08)",
              },
              py: 1.5,
              fontSize: "1.1rem",
            }}
          >
            Indietro
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={onContinua}
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              flex: 2,
              bgcolor: "#13b86d",
              "&:hover": { bgcolor: "#10ac7d" },
              py: 1.5,
              fontSize: "1.1rem",
            }}
          >
            Continua con i Dati Personali
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default PremioTotaleCard;
